import { getPlaceUrl } from '../urls';

export function getPlaceSchema({
  name,
  countryId,
  regionCode,
  slug,
  latitude,
  longitude,
}: {
  name: string;
  countryId: string;
  regionCode: string;
  slug: string;
  latitude: number;
  longitude: number;
}): string {
  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'City',
    name,
    url: getPlaceUrl(countryId, regionCode, slug),
    latitude,
    longitude,
  });
}
